import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "../Components/Drawer/Sidebar";

const drawerWidth = 150;

const MainScreen = () => {
  return (
    <Box sx={{ display: "flex", height: "100vh", background: "#E5E5E5" }}>
      {/* Sidebar with fixed width */}
      <Box>
        <Sidebar />
      </Box>

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: "100%", md: `calc(100% - ${drawerWidth}px)` },
          // ml:'1px',
          overflowX: "hidden",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainScreen;
